export class Prevendor {

    id: number;
    companyName: string;
    address: string;
    city: string;
    state: string;
    stateId: number;
    country: string;
    countryId: number;
    pinCode: string;
    email: string;
    contactPersonName: string;
    mobileNo: string;
    natureOfBusiness: string;
    natureOfBusinessId: number;
    panNo: string;
    gstRegdNo: string;
    gstRegdAddress: string;
    ntpcOrGeApproved: string;
    ntpcOrGeApprovedId: number;
    executedForNtpcGe: string;
    executedForNtpcGeId: number;
    comments: string;
    cond_1_SustainableDevelop: string;
    cond_2_Confiden_Agreement: string;
    cond_3_GCC: string;
    cond_4_EHS: string;
    cond_5_Erection: string;
    cond_6_LaborWelfare: string;
    sMG_Nos: string;
    sSG_Nos: string;
    vendorType: string;

    Currency :string;
    CentralSaleTaxNo :string;
    VATRegNo :string;
    CompanyTaxNo :string;
    CompetencyParameters :string;
    
    //not in prevendor
    /*
    applicationDate : string;
    natureOfwork : string;
    natureOfworkId : number;
    NameOfCeoProprietorPartner : string;
    NameofAuthorisedSignatory : string;
    DesignationOfContactPerson : string;
    STDCode : string;
    TelephoneNo : string;
    TypeOfCompany : string;
    TypeOfCompanyId : number;
    MSMECategory : string;
    MSMECategoryId : number;
    DateOfIncorporation : Date;
    GSTValidity : Date;
    MSMERegdNo : string;
    MSMEValidity : Date;
    EPFRegdNo : string;
    EPFValidity : Date;
    ESIRegdNo : string;
    ESIValidity : Date;
    BankName : string;
    AddressofBank : string;
    Location : string;
    IFSCCode : string;
    AccountNo : string;
    ISOCertification : string;
    ISOCertificationId : number;
    Technicalcollaboration : string;
    RDSetup : string;
    FinancialYear1 : string;
    SalesTurnOver1 : string;
    ProfitBeforeTax1 : string;
    NetWorthCurrency1 : string;
    FinancialYear2 : string;
    SalesTurnOver2 : string;
    ProfitBeforeTax2 : string;
    NetWorthCurrency2 : string;
    FinancialYear3 : string;
    SalesTurnOver3 : string;
    ProfitBeforeTax3 : string;
    NetWorthCurrency3 : string;
    AvgTurnOverCurrency : string;
    EngineersinManufacturing : number;
    EngineersInQA_Inspection : number;
    EngineersInAfterSalesService : number;
    EngineersInOtherDepartments : number;
    DipHoldersInManufacturing : number;
    DipHoldersInQA_Inspection : number;
    DipHoldersInAfterSalesService : number;
    DipHoldersInOtherDepartments : number;
    OthersInManufacturing : number;
    OthersInQA_Inspection : number;
    OthersInAfterSalesService : number;
    OthersInOtherDepartments : number;
    TotalEngineers : number;
    TotalDiplomaHolders : number;
    TotalOtherStuff : number;
    Status : string;
    TotalTurnover : string;
    AuthorisedSignatoryEmail : string;
    CEOMobileNo : string;
    CEOTelephone : string;
    AuthorisedSignatoryDesignation : string;
    AuthorisedSignatoryMobileNo : string;
    AuthorisedSignatoryTelephone : string;
    ContactPersonDesignation : string;
    ContactPersonEmail : string;
    ContactPersonMobile : string;
    ContactPersonTelephone : string;
    CEOSTDCode : string;
    GSTListStatus : string;
    GSTNos : string;
    EnlistedVendor : string;
    AccountType : string;
    SmgSsg : string;
    SmgSsgNos : string;
    SmgSsgCount : number;
    VendorNo : number;
    GSTRegArray : string;
    GSTAddressArray : string;
    GSTStateArray : string;
    Firstlogin : string;
    
    VendTotalSteps : number;
    VendCurrentSteps : number;
    VendTotalStepsString : string;
    VendCurrentStepsString : string;
    VendRegisterStatus : string;
    VendEnlistmentStatus : string;
    VendEnlistmentCompeted : boolean;
    IsVendorActive : boolean;
    */
}
